/**
 * Trascinamento con dito o mouse per i caroselli del tema.
 *
 * I caroselli non scorrono da soli: il contenitore ha overflow hidden e le
 * schede si spostano cambiando una transform, quindi il browser non ha nulla
 * da far scorrere e sul telefono restavano ferme sotto il dito. Le frecce
 * erano l'unico modo per muoverli, che su un telefono non e' un modo.
 *
 * Il gesto non ricalcola le posizioni per conto suo: segue il dito e alla fine
 * chiama goNext o goPrev del carosello, che sanno gia' gestire il giro
 * infinito con i cloni. Cosi' esiste una sola logica di scorrimento e il
 * trascinamento non puo' disallinearsi dalle frecce.
 *
 * Il carosello deve esporre: track, position, step, applyTransform(animate),
 * goNext() e goPrev().
 */
(function () {
  /** Spostamento oltre il quale il gesto vale come cambio di scheda. */
  var SOGLIA_CAMBIO = 40;
  /** Spostamento sotto il quale non si decide ancora la direzione. */
  var SOGLIA_DIREZIONE = 6;

  window.lionTrascinamentoCarosello = function (carosello) {
    var track = carosello.track;
    if (!track || typeof carosello.applyTransform !== 'function') return;

    var attivo = false;
    var orizzontale = null;
    var idPuntatore = null;
    var partenzaX = 0;
    var partenzaY = 0;
    var posizioneIniziale = 0;
    var trascinato = false;

    var termina = function (dx) {
      track.classList.remove('is-dragging');
      carosello.position = posizioneIniziale;
      carosello.applyTransform(false);
      if (dx <= -SOGLIA_CAMBIO) {
        carosello.goNext();
      } else if (dx >= SOGLIA_CAMBIO) {
        carosello.goPrev();
      } else {
        carosello.applyTransform(true);
      }
    };

    track.addEventListener('pointerdown', function (evento) {
      if (evento.pointerType === 'mouse' && evento.button !== 0) return;
      attivo = true;
      orizzontale = null;
      trascinato = false;
      idPuntatore = evento.pointerId;
      partenzaX = evento.clientX;
      partenzaY = evento.clientY;
      posizioneIniziale = carosello.position;
    });

    track.addEventListener('pointermove', function (evento) {
      if (!attivo || evento.pointerId !== idPuntatore) return;
      var dx = evento.clientX - partenzaX;
      var dy = evento.clientY - partenzaY;

      if (orizzontale === null) {
        if (Math.abs(dx) < SOGLIA_DIREZIONE && Math.abs(dy) < SOGLIA_DIREZIONE) return;
        // Se il gesto e' piu' verticale che orizzontale la pagina deve poter
        // scorrere: ci togliamo di mezzo invece di rubare il movimento.
        orizzontale = Math.abs(dx) > Math.abs(dy);
        if (!orizzontale) {
          attivo = false;
          return;
        }
        // La cattura serve a non perdere il gesto se il dito esce dal
        // carosello. Se il browser la rifiuta il trascinamento deve
        // funzionare lo stesso, quindi l'errore non puo' fermare il gesto.
        try {
          track.setPointerCapture(evento.pointerId);
        } catch (errore) {
          /* si continua senza cattura */
        }
        track.classList.add('is-dragging');
      }

      trascinato = true;
      carosello.position = posizioneIniziale - dx;
      carosello.applyTransform(false);
    });

    var suRilascio = function (evento) {
      if (!attivo || evento.pointerId !== idPuntatore) return;
      attivo = false;
      if (orizzontale !== true) return;
      termina(evento.clientX - partenzaX);
    };

    track.addEventListener('pointerup', suRilascio);
    track.addEventListener('pointercancel', suRilascio);
    track.addEventListener('lostpointercapture', suRilascio);

    // Dopo un trascinamento il dito si alza sopra una scheda prodotto: senza
    // questo, rilasciare il gesto aprirebbe il prodotto sotto il dito.
    track.addEventListener(
      'click',
      function (evento) {
        if (!trascinato) return;
        trascinato = false;
        evento.preventDefault();
        evento.stopPropagation();
      },
      true
    );
  };
})();
